/**
 * @title secure-key-member-verification.js: Sub-module of Account feature
 * @description This module provides membership verification functionality for CA.
 * @dependency utility.js, costcodialog.js
 */
define([], function () {
    let SecureKeyMemberVerification = {
        init: function () {        
            if(typeof localStorage.getItem('dmcInfo') !== 'undefined' && !$.isEmptyObject(localStorage.getItem('dmcInfo'))){   
                console.log('Retrieving  DMC Information from Local Storage')
                let dmcInfo = localStorage.getItem('dmcInfo').split('|');
                if(typeof dmcInfo[0] !== 'undefined'){
                	hashedUserId =  dmcInfo[0];
                }
                if(typeof hashedUserId !== 'undefined' && hashedUserId !== '' 
                	&& typeof $.cookie('hashedUserId') !== 'undefined' && $.cookie('hashedUserId') !== '' && $.cookie('hashedUserId') === hashedUserId){ 
                	   if(typeof dmcInfo[1] !== 'undefined'){
                		   isDmcPage = dmcInfo[1];
                	   }
                	   if(typeof dmcInfo[2] !== 'undefined'){
                		   deviceId = dmcInfo[2];
                	   }
                }
            }
            if(document.querySelectorAll('.mdc-text-field')[0] !== undefined){
                new mdc.textField.MDCTextField(document.querySelectorAll('.mdc-text-field')[0]);
            }
            if($('#displaySuccessPopup').val() !== undefined || $('#displayErrorPopup').val() !== undefined) {
                let page = $('[data-page]').data('page') || '';
                if(page !== undefined && page === 'verify-membership') {
        			// new verify me page
                    if($('#displaySuccessPopup').val() !== undefined) {
                        this.displayErrorInModal('tmpl_membership_verify_result_secure_key', ['verify-membership',  'displaySecureKeyPopUp', 'success', 'verify-membership-dialog-verifyme']);
                    }else {
                        this.displayErrorInModal('tmpl_membership_verify_result_secure_key', ['verify-membership', 'displaySecureKeyPopUp', 'failed', 'verify-membership-dialog-verifyme']);
                    }
                }else {
        			// account details page
                    if($('#displaySuccessPopup').val() !== undefined) {
                    	window.digitalDataEvents = window.digitalDataEvents || [];
                    	digitalDataEvents.push( { uimsg:"Member Verification Process | Verification Success" } )
                        this.displayErrorInModal('tmpl_membership_verify_result_secure_key', ['success', 'displaySecureKeyPopUp', 'verify-membership-dialog-verifyme']);
                    }else {
                    	window.digitalDataEvents = window.digitalDataEvents || [];
                    	digitalDataEvents.push( { uimsg:"Member Verification Flow | Information Does Not Match Records Error" } );
                        this.displayErrorInModal('tmpl_membership_verify_result_secure_key', ['failed', 'displaySecureKeyPopUp', 'verify-membership-dialog-verifyme']);
                    }
                }
            }
        },

        membershipNumber: null,

        getForm: function () {
            return $('#MemberVerificationForm');
        },
        
        getForm1: function () {
            return $('#MemberVerificationForm1');
        },
        
        onKeyUpMembershipValidation: function() {
        	//Trigger only if validation error is visible
            if($('#membershipNumberToVerify').parent()[0].nextElementSibling.style.display === 'block') {
                const membershipNumber = $('#membershipNumberToVerify').val();
                if ($.isNumeric(membershipNumber) && membershipNumber.length === 12) {
                    $('#membershipNumberToVerify').parent()[0].classList.remove('mdc-text-field--invalid');
                    $('#membershipNumberToVerify')[0].classList.remove('highlightError');
                    $('#membershipNumberToVerify').parent().find('.mdc-notched-outline__leading').css('border-color', '');
                    $('#membershipNumberToVerify').parent().find('.mdc-notched-outline__notch').css('border-color', '');
                    $('#membershipNumberToVerify').parent().find('.mdc-notched-outline__notch').find('label').css('color', '');
                    $('#membershipNumberToVerify').parent().find('.mdc-notched-outline__trailing').css('border-color', '');
                    $('#membershipNumberToVerify').removeProp('required');
                    $('#membershipNumberToVerify').removeAttr('minlength');
                    $('#membershipNumberToVerify').parent()[0].nextElementSibling.style.display = 'none';
                }
            }
        },       
        validateMembershipNumber: function () {
            const membershipNumber = $('#membershipNumberToVerify').val();
            isValid = false;                
            if (!($.isNumeric(membershipNumber) && membershipNumber.length === 12)) {
            	window.digitalDataEvents = window.digitalDataEvents || [];
            	digitalDataEvents.push( { uimsg:"Member Verification Flow | Enter Valid Membership Number Error" } )
                $('#membershipNumberToVerify').parent()[0].classList.add('mdc-text-field--invalid');
                $('#membershipNumberToVerify')[0].classList.add('highlightError');
                $('#membershipNumberToVerify').parent().find('.mdc-notched-outline__leading').attr('style', 'border-color: #d32029 !important');
                $('#membershipNumberToVerify').parent().find('.mdc-notched-outline__notch').css({'cssText': 'border-color: #d32029 !important'});
                $('#membershipNumberToVerify').parent().find('.mdc-notched-outline__notch').find('label').attr('style', 'color: #d32029 !important');
                $('#membershipNumberToVerify').parent().find('.mdc-notched-outline__trailing').attr('style', 'border-color: #d32029 !important');
                $('#membershipNumberToVerify').prop('required', true);
                $('#membershipNumberToVerify').attr('minlength', '12');
                $('#membershipNumberToVerify').parent()[0].nextElementSibling.children[0].innerHTML= messages.ERR_INVALID_MEMBERSHIP_NO;
                $('#membershipNumberToVerify').parent()[0].nextElementSibling.style.display = 'block';
                $('#membershipNumberToVerify').focus();
                isValid = false;
            }else {
                $('#membershipNumberToVerify').parent()[0].classList.remove('mdc-text-field--invalid');
                $('#membershipNumberToVerify')[0].classList.remove('highlightError');
                $('#membershipNumberToVerify').parent().find('.mdc-notched-outline__leading').css('border-color', '');
                $('#membershipNumberToVerify').parent().find('.mdc-notched-outline__notch').css('border-color', '');
                $('#membershipNumberToVerify').parent().find('.mdc-notched-outline__notch').find('label').css('color', '');
                $('#membershipNumberToVerify').parent().find('.mdc-notched-outline__trailing').css('border-color', '');
                $('#membershipNumberToVerify').removeProp('required');
                $('#membershipNumberToVerify').removeAttr('minlength');
                $('#membershipNumberToVerify').parent()[0].nextElementSibling.style.display = 'none';
                isValid = true;
            }            
            return isValid;            
        },
        
        validateLastName: function () {
            const lastName = $.trim($('#questionLastName').val());
            isLastNameValid = false;
            if (lastName !== undefined && lastName !== '') {
                $("#questionLastName").parent()[0].classList.remove("mdc-text-field--invalid");
                $("#questionLastName")[0].classList.remove("highlightError");
                $("#questionLastName").parent()[0].nextElementSibling.children[0].innerHTML = "";
                $("#questionLastName").parent()[0].nextElementSibling.style.display = 'none';                
                isLastNameValid =  true;
            }else{
                $('#questionLastName').parent()[0].classList.add('mdc-text-field--invalid');
                $('#questionLastName')[0].classList.add('highlightError');
                $('#questionLastName').parent()[0].nextElementSibling.children[0].innerHTML= messages.ERR_INVALID_LASTNAME;
                $('#questionLastName').parent()[0].nextElementSibling.style.display = 'block';
                $('#questionLastName').focus();
                isLastNameValid =  false;
            }              
            return isLastNameValid;
        },
        
        validateZipCode: function () {
            const zipCode = $.trim($('#questionZip').val());
            isZipValid = false;
            if (zipCode !== undefined && zipCode !== '' && (COSTCO.util.POSTAL_CODE_REGEX_CA).test(zipCode)) {
                $("#questionZip").parent()[0].classList.remove("mdc-text-field--invalid");
                $("#questionZip")[0].classList.remove("highlightError");
                $("#questionZip").parent()[0].nextElementSibling.children[0].innerHTML = "";
                $("#questionZip").parent()[0].nextElementSibling.style.display = 'none';                
                isZipValid = true;
            } else {
                $('#questionZip').parent()[0].classList.add('mdc-text-field--invalid');
                $('#questionZip')[0].classList.add('highlightError');
                $('#questionZip').parent()[0].nextElementSibling.children[0].innerHTML= messages.ERR_ENTER_ZIPCODE;
                $('#questionZip').parent()[0].nextElementSibling.style.display = 'block';
                $('#questionZip').focus();
                isZipValid = false;
            }                                  
            return isZipValid;
        },
        
        onKeyUpLastNameValidation: function() {
        	//Trigger only if validation error is visible
            if($('#questionLastName').parent()[0].nextElementSibling.style.display === 'block') {
                const lastName = $.trim($('#questionLastName').val());
                if (lastName !== undefined && lastName !== '') {
                    $('#questionLastName').parent()[0].classList.remove('mdc-text-field--invalid');
                    $('#questionLastName')[0].classList.remove('highlightError');
                    $('#questionLastName').parent().find('.mdc-notched-outline__leading').css('border-color', '');
                    $('#questionLastName').parent().find('.mdc-notched-outline__notch').css('border-color', '');
                    $('#questionLastName').parent().find('.mdc-notched-outline__notch').find('label').css('color', '');
                    $('#questionLastName').parent().find('.mdc-notched-outline__trailing').css('border-color', '');
                    $('#questionLastName').removeProp('required');
                    $('#questionLastName').parent()[0].nextElementSibling.style.display = 'none';
                }        	
            }
        },
        
        onKeyUpZipCodValidation: function() {
        	//Trigger only if validation error is visible
            if($('#questionZip').parent()[0].nextElementSibling.style.display === 'block') {
                const zipCode = $.trim($('#questionZip').val());
                if (zipCode !== undefined && zipCode !== '' && (COSTCO.util.POSTAL_CODE_REGEX_CA).test(zipCode)) {
                    $('#questionZip').parent()[0].classList.remove('mdc-text-field--invalid');
                    $('#questionZip')[0].classList.remove('highlightError');
                    $('#questionZip').parent().find('.mdc-notched-outline__leading').css('border-color', '');
                    $('#questionZip').parent().find('.mdc-notched-outline__notch').css('border-color', '');
                    $('#questionZip').parent().find('.mdc-notched-outline__notch').find('label').css('color', '');
                    $('#questionZip').parent().find('.mdc-notched-outline__trailing').css('border-color', '');
                    $('#questionZip').removeProp('required');
                    $('#questionZip').parent()[0].nextElementSibling.style.display = 'none';
                }
            }
        },
        
        validateLastNameZipCode: function () {	
            const lastName = $.trim($('#questionLastName').val());
            isLastNameValid = false;
            if (lastName !== undefined && lastName !== '') {
                $("#questionLastName").parent()[0].classList.remove("mdc-text-field--invalid");
                $("#questionLastName")[0].classList.remove("highlightError");
                $("#questionLastName").parent().find(".mdc-notched-outline__leading").css('border-color','');
                $("#questionLastName").parent().find(".mdc-notched-outline__notch").css('border-color','');
                $("#questionLastName").parent().find(".mdc-notched-outline__notch").find('label').css('color','');
                $("#questionLastName").parent().find(".mdc-notched-outline__trailing").css('border-color','');
                $("#questionLastName").removeProp('required');
                $("#questionLastName").parent()[0].nextElementSibling.children[0].innerHTML = "";
                $("#questionLastName").parent()[0].nextElementSibling.style.display = 'none';                
                isLastNameValid =  true;
            }else{
            	window.digitalDataEvents = window.digitalDataEvents || [];
            	digitalDataEvents.push( { uimsg:"Member Verification Flow | Enter Your Last Name Error" } )
                $('#questionLastName').parent()[0].classList.add('mdc-text-field--invalid');
                $('#questionLastName')[0].classList.add('highlightError');
                $('#questionLastName').parent().find('.mdc-notched-outline__leading').attr('style', 'border-color: #d32029 !important');
                $('#questionLastName').parent().find('.mdc-notched-outline__notch').css({'cssText': 'border-color: #d32029 !important'});
                $('#questionLastName').parent().find('.mdc-notched-outline__notch').find('label').attr('style', 'color: #d32029 !important');
                $('#questionLastName').parent().find('.mdc-notched-outline__trailing').attr('style', 'border-color: #d32029 !important');
                $('#questionLastName').prop('required', true);
                $('#questionLastName').parent()[0].nextElementSibling.children[0].innerHTML= messages.ERR_INVALID_LASTNAME;
                $('#questionLastName').parent()[0].nextElementSibling.style.display = 'block';
                $('#questionLastName').focus();
                isLastNameValid =  false;
            }        
            const zipCode = $.trim($('#questionZip').val());
            isZipValid = false;
            if (zipCode !== undefined && zipCode !== '' && (COSTCO.util.POSTAL_CODE_REGEX_CA).test(zipCode)) {
                $("#questionZip").parent()[0].classList.remove("mdc-text-field--invalid");
                $("#questionZip")[0].classList.remove("highlightError");
                $("#questionZip").parent().find(".mdc-notched-outline__leading").css('border-color','');
                $("#questionZip").parent().find(".mdc-notched-outline__notch").css('border-color','');
                $("#questionZip").parent().find(".mdc-notched-outline__notch").find('label').css('color','');
                $("#questionZip").parent().find(".mdc-notched-outline__trailing").css('border-color','');
                $("#questionZip").removeProp('required');
                $("#questionZip").parent()[0].nextElementSibling.children[0].innerHTML = "";
                $("#questionZip").parent()[0].nextElementSibling.style.display = 'none';                
                isZipValid = true;
            } else {
            	window.digitalDataEvents = window.digitalDataEvents || [];
            	digitalDataEvents.push( { uimsg:"Member Verification Flow | Enter a Valid Postal Code Error" } )
            	$('#questionZip').parent()[0].classList.add('mdc-text-field--invalid');
                $('#questionZip')[0].classList.add('highlightError');
                $('#questionZip').parent().find('.mdc-notched-outline__leading').attr('style', 'border-color: #d32029 !important');
                $('#questionZip').parent().find('.mdc-notched-outline__notch').css({'cssText': 'border-color: #d32029 !important'});
                $('#questionZip').parent().find('.mdc-notched-outline__notch').find('label').attr('style', 'color: #d32029 !important');
                $('#questionZip').parent().find('.mdc-notched-outline__trailing').attr('style', 'border-color: #d32029 !important');
                $('#questionZip').prop('required', true);
                $('#questionZip').parent()[0].nextElementSibling.children[0].innerHTML= messages.ERR_ENTER_ZIPCODE;
                $('#questionZip').parent()[0].nextElementSibling.style.display = 'block';
                if (isLastNameValid) {
                    $('#questionZip').focus();
                }
                isZipValid = false;
            }                                     
            return isZipValid && isLastNameValid;
        },

        /**
         * Submits request for membership verification steps
         * @param  {String} urlWithParams Service URL with query string parameters appended
         * @return {jQuery.Deferred}      The deferred object
         */
        submitRequest: function(urlWithParams) {
            return COSTCO.util.ajax({
                    type: 'POST',
                    url: urlWithParams,
                    dataType: 'json',
                    beforeSend: function(xhr){
                    	xhr.setRequestHeader('ApplicationID', applicationId);
                    },
                })
                // This returns a chainable promise.
                .then((data) => {
                    if (data && (data.CRM_ERROR_FRAMEWORK || data.errorMessage)) {
                        let errorTmpl = 'tmpl_membership_verify_err_service_error_secure_key';
                        let errorTmplData = {
                            membershipNumber: this.membershipNumber,
                            error: data.errorMessage,
                        };
                        if (data.errorMessage) {
                            errorTmpl = 'tmpl_membership_verify_err_secure_key';
                        }
                        switch (data.CRM_ERROR_FRAMEWORK) {
                            case 'ERROR_EXCEEDED_MAX_AUTH_ATTEMPTS':
                            	window.digitalDataEvents = window.digitalDataEvents || [];
                            	digitalDataEvents.push( { uimsg:"Member Verification Flow | Exceeded Number of Attempts Error" } );
                                errorTmpl = 'tmpl_membership_verify_err_max_retries_reached_secure_key';
                                break;
                            case 'ERROR_PRESCREEN_ATTEMPT_FAILED':
                                switch (data.CRM_MEMBER_TYPE) {
                                    case 'E':
                                        errorTmpl = 'tmpl_membership_verify_err_employee_membership_secure_key';
                                        break;
                                    case 'T':
                                        errorTmpl = 'tmpl_membership_verify_err_trial_membership_secure_key';
                                        break;
                                    case 'X':
                                        errorTmpl = 'tmpl_membership_verify_err_inactive_membership_secure_key';
                                        break;
                                    default:
                                        errorTmpl = 'tmpl_membership_verify_err_try_again_secure_key';
                                }
                        }
                        if(errorTmpl === 'tmpl_membership_verify_err_service_error_secure_key'){
                        	window.digitalDataEvents = window.digitalDataEvents || [];
                        	digitalDataEvents.push( { uimsg:"Member Verification Flow | Not Able to Verify Error" } );
                        }
                        if(errorTmpl === 'tmpl_membership_verify_err_try_again_secure_key'){
                        	window.digitalDataEvents = window.digitalDataEvents || [];
                        	digitalDataEvents.push( { ui:"Member Verification Flow | Information Does Not Match Records Error" } );
                        }
                        return $.Deferred().reject(errorTmpl, errorTmplData);
                    }
                    return $.Deferred().resolve(data);
                })
                .fail((errorTmpl, errorTmplData) => {
                    if (errorTmpl) {
                        this.displayErrorInModal(errorTmpl, errorTmplData);
                    }
                });
        },

        /**
         * Invalidates session on backend for membership verification process
         */
        invalidateSession: function () {
            let url = this.makeVerificationUrl({
                membershipNumber: this.membershipNumber,
                invalidSession: true,
            });
            this.submitRequest(url);
        },

        /**
         * Makes URL with string params for membership account verification services
         * @param  {Object} params  JSON obj with params to be put in URL as a query string e.g. {membershipNumber: 4444333322221111, invalidSession: true}
         * @return {String}         URL for membership account verification services with query string paramaters
         *                          e.g. /AjaxMembershipAccountVerificationCmd?membershipNumber=4444333322221111&invalidSession=true
         */
        makeVerificationUrl: function (params) {
            return COSTCO.util.makeUrl('/AjaxSecureKeyMembershipAccountVerificationCmd', params);
        },

        /**
         * Opens membership verification dialog
         * @param  {number} membershipNum Membership number
         */
        openMembershipVerificationDialog: function (membershipNum) {
            this.membershipNumber = membershipNum;
            let doNotCloseModalFlag = false;
            
            window.digitalDataEvents = window.digitalDataEvents || [];
            digitalDataEvents.push( { uimsg:"navName:DMC | Verify Your Membership | Verify Now" } );
            
            if(typeof localStorage.getItem('dmcInfo') !== 'undefined' && !$.isEmptyObject(localStorage.getItem('dmcInfo'))){   
                console.log('Retrieving  DMC Information from Local Storage')
                let dmcInfo = localStorage.getItem('dmcInfo').split('|');
                if(typeof dmcInfo[0] !== 'undefined'){
                    hashedUserId =  dmcInfo[0];
                }
                if(typeof hashedUserId !== 'undefined' && hashedUserId !== '' 
                    && typeof $.cookie('hashedUserId') !== 'undefined' && $.cookie('hashedUserId') !== '' && $.cookie('hashedUserId') === hashedUserId){ 
                    if(typeof dmcInfo[1] !== 'undefined'){
                        isDmcPage = dmcInfo[1];
                    }
                    if(typeof dmcInfo[2] !== 'undefined'){
                        deviceId = dmcInfo[2];
                    }
                }
            }
            let settings = {
                dialogclasses: 'verify-membership-dialog-verifyme',
                title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
                body: COSTCO.util.tmpl('tmpl_membership_verify_number_secure_key', {
                    membershipNumber: this.membershipNumber,
                }),
                preventClose: doNotCloseModalFlag,
                primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
                primary_button_style: 'rounded',
                secondary_button_style: 'rounded',
                secondary: messages.MEMBERVERIFICATION_MEMBERSHIP__Cancel_ButtonText,
                primary_event: () => {
                    if (this.validateMembershipNumber()) {
                        this.membershipNumber = parseInt($('#membershipNumberToVerify').val());
                        let url = this.makeVerificationUrl({
                            membershipNumber: this.membershipNumber,
                        });
                        this.submitRequest(url)
                            .then((data) => {
                                    this.showPrescreen(data);
                            });
                    }
                },
                secondary_event: () => {
                    if (isDmcPage) {
                        this.proceedeToDMCCheck('verification', false);
                    } else {
                        COSTCO.dialog.close();
                    }
                },
                close: () => {
                    if (isDmcPage) {
                        this.proceedeToDMCCheck('verification', false);
                    } else {
                        COSTCO.dialog.close();
                    }
                },
                onshown: () => {
                    COSTCO.util.maskMembershipInput();
                    if(document.querySelectorAll('.mdc-text-field')[0] !== undefined){
                        new mdc.textField.MDCTextField(document.querySelectorAll('.mdc-text-field')[0]);
                    }
                    if(document.querySelectorAll('.mdc-text-field')[1] !== undefined){
                        new mdc.textField.MDCTextField(document.querySelectorAll('.mdc-text-field')[1]);
                    }
                    $('#costcoModalBtn2').on('click', function(){
                        $('#costcoModalBtn2').blur();
                    });
                },
            };
            COSTCO.dialog.createExtDialogBox(settings);
        },

        /**
         * Shows prescreen (last name / zip code form)
         * @param  {Object} data Data response returned from server
         */
        showPrescreen: function (indata) {
            COSTCO.dialog.updateModal({
                title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
                body: COSTCO.util.tmpl('tmpl_membership_verify_prescreen_secure_key', {}),
                primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
                secondary: messages.MEMBERVERIFICATION_MEMBERSHIP__Cancel_ButtonText,     
                primary_button_style: 'rounded',
                secondary_button_style: 'rounded',
                primary_event: () => {
                    if (this.validateLastNameZipCode()) {
                        let url = this.makeVerificationUrl({
                            lastName: $('#questionLastName').val().trim(),
                            zipCode: $('#questionZip').val().trim(),
                        });
                        // after submit of prescreen fields to the verify command
                        // the command will return a flag called showVerifyMeModal 
                        // if true show the Verify Me modal
                        // note: no API calls to Verify Me have been done yet
                        this.submitRequest(url)
                            .then((data) => {
                            if(data){
                                this.showVerifyMeModal(data);
                            }
                        });
                    }
                },
                secondary_event: () => {
                    if (isDmcPage) {
                        this.proceedeToDMCCheck('verification', false);
                    } else {
                        COSTCO.dialog.close();
                        this.invalidateSession();
                    }
                },
                onshown: () => {
                    this.setUpKeyBindings();
                },
                close: () => {
                    if (isDmcPage) {
                        this.proceedeToDMCCheck('verification', false);
                    } else {
                        COSTCO.dialog.close();
                        this.invalidateSession();
                    }
                },                
            });
            $('#questionZip').mask('S0S 0S0'); 
            if(document.querySelectorAll('.mdc-text-field')[2] !== undefined){
                new mdc.textField.MDCTextField(document.querySelectorAll('.mdc-text-field')[2]);
            }	
            if(document.querySelectorAll('.mdc-text-field')[1] !== undefined){
                new mdc.textField.MDCTextField(document.querySelectorAll('.mdc-text-field')[1]);
            }
            if(document.querySelectorAll('.mdc-text-field')[0] !== undefined){
                new mdc.textField.MDCTextField(document.querySelectorAll('.mdc-text-field')[0]);
            }
            COSTCO.util.focusWithoutScroll($("#costcoModal"));
        },
        
        /**
         * Shows VerifyMeModal
         * @param  {Object} data Data response returned from server
         */
        showVerifyMeModal: function (data) {
            COSTCO.dialog.updateModal({
                title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
                body: COSTCO.util.tmpl('tmpl_membership_verify_applink_secure_key', {}),
                showVerifyMeModal: true,
                showVerifyMeModalText:COSTCO.util.tmpl('tmpl_membership_continue_with_verifiedme', {}), 
                primary: '',
                primary_button_style: 'rounded',
                secondary_button_style: 'rounded',
                secondary: messages.MEMBERVERIFICATION_MEMBERSHIP__Cancel_ButtonText,
                footerText:COSTCO.util.tmpl('tmpl_membership_verify_applink_secure_key_footer'),
                primary_event: () => {
                    // use the fromCostcoPage for redirect if it is supplied
                    // otherwise use the view/command name from the URL
                    let fromPage;
                    $.urlParam = function(name){
                        let results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
                        if (results === null){
                            return null;
                        } else {
                            return decodeURI(results[1]) || 0;
                        }
                    };
                    fromPage = $.urlParam('fromCostcoPage');
                    if (!fromPage) {
                        fromPage = window.location.href.split('/').pop();
                        fromPage = fromPage.split('?').shift(1);
                    }
                    let url = this.makeVerificationUrl({
                        continueToVerifyMe: true,
                        fromCostcoPage: fromPage,
                    });
                    COSTCO.dialog.updateModal({
                        title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
                        body: COSTCO.util.tmpl('tmpl_membership_verify_loading_secure_key', {}),
                        onshown: () => {
                        COSTCO.util.maskMembershipInput();
                        },
                    });
                    this.submitRequest(url)
                        .then((data) => {
                            // get applink from data that was returned by the submitRequest
                            if(data && data.secureKeyAppLink !== undefined) {
                                window.location.href=data.secureKeyAppLink; 
                            }else{
                                let errorTmplData = {
                                errorMessage : data.errorMessage,
                                };
                                this.displayErrorInModal('tmpl_membership_verify_err_service_error_secure_key', errorTmplData);
                            }
                        });
                },
                secondary_event: () => {
                    if (isDmcPage) {
                        this.proceedeToDMCCheck('verification', false);
                    } else {
                        COSTCO.dialog.close();
                        this.invalidateSession();
                    }
                },
                close: () => {
                    if (isDmcPage) {
                        this.proceedeToDMCCheck('verification', false);
                    } else {
                        COSTCO.dialog.close();
                        this.invalidateSession();
                    }
                },
                onshown: () => {
                    this.setUpKeyBindings();
                    COSTCO.util.maskMembershipInput();
                },
            });
            COSTCO.util.focusWithoutScroll($("#costcoModal"));
        },
        
        /**
         * Transfer request to DMC handler
         */
        proceedeToDMCCheck: function (action, actionSuccessful) {
            COSTCO.dialog.close();
            let command = '/DMCCheck';
            let queryStart = '?';
            let queryConcat = '&';
            let queryAction = 'action=' + action;
            let queryDeviceId = 'deviceId=' + deviceId;
            let queryVerified = 'verified=' + actionSuccessful;
            let queryRenewalCanceled = 'renewCanceled=' + actionSuccessful;
            let queryString = queryStart + queryAction + queryConcat + queryDeviceId + queryConcat;
            if (action === 'renewal')
                queryString += queryRenewalCanceled;
            else
                queryString += queryVerified;
            let newURL = window.location.protocol + '//' + window.location.host + command + queryString;
            window.location.replace(newURL);
        },
        
        redirect : function(data){
            if(data[0] === 'verify-membership'){
                console.log('redirecting from verify flow... ');
                if(data[2] === 'success' && !isDmcPage){
                    window.location.href='/';
                }else if(data[2] === 'success' && isDmcPage){
                    console.log('redirect as isDMCPage to then proceed to DMC from verification flow');
                    if(typeof hashedUserId !== 'undefined' && hashedUserId !== '' 
                        && typeof $.cookie('hashedUserId') !== 'undefined' && $.cookie('hashedUserId') !== '' && $.cookie('hashedUserId') === hashedUserId){ 		
                        localStorage.removeItem('dmcInfo');
                    }
                    this.proceedeToDMCCheck('verification', true);
                }else{                	 
                    console.log('redirect back to verifyMembershipView interupt page');
                    window.location.href = '/VerifyMembershipView?verifyMeBypass=false';
                }
            }else{
        		// adding a flag to the URL so that popup is displayed only once
                if(data[0] === 'success'){
                    //TODO: change to get query string and append the success into query string
                    window.location.href = '/AccountInformationView?secureKeySuccess=true';   
                }else {
                    //TODO: change to get query string and don't append the success into query string
                    window.location.href = '/AccountInformationView?verifyMeBypass=false';
                }
            }
        },

        /**
         * Update modal with error text from prepared template.
         * @param  {string} errorTemplate   Template id
         * @param  {Object} data            Data used to populate in template
         */
        displayErrorInModal: function (errorTemplate, data) {     
            COSTCO.dialog.updateModal({
                title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
                body: COSTCO.util.tmpl(errorTemplate, data),
                primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
                primary_button_style: 'rounded',
                dialogclasses: $.inArray('verify-membership-dialog-verifyme', data) !== -1 ? 'verify-membership-dialog-verifyme' : '',
                primary_event: () => {
                    COSTCO.dialog.close();                    
                    if(data[1] !== undefined && data[1] === 'displaySecureKeyPopUp'){
                        this.redirect(data);
                    }
                },
                close: () => {
                    if(isDmcPage) {
                        if(typeof hashedUserId !== 'undefined' && hashedUserId !== '' 
                            && typeof $.cookie('hashedUserId') !== 'undefined' && $.cookie('hashedUserId') !== '' && $.cookie('hashedUserId') === hashedUserId){ 		
                            localStorage.removeItem('dmcInfo');
                        }
                        this.proceedeToDMCCheck('verification', false);
                    } else {
                        COSTCO.dialog.close();
                        if(data[1] !== undefined && data[1] === 'displaySecureKeyPopUp'){
                            this.redirect(data);
                        }
                    }
                },
                onshown: () => {
                    this.setUpKeyBindings();
                    COSTCO.util.maskMembershipInput();
                },
            });
            COSTCO.util.focusWithoutScroll($("#costcoModal"));
        },

        setUpKeyBindings: function () {
            $('#costcoModal').off('keyup');
            $('#costcoModal').keyup(function(e) {
                // ESCAPE key pressed
                if (e.keyCode === 27) {
                    $('#costcoModalBtn2').click();
                }
                //ENTER key pressed
                if (e.keyCode === 13) {
                    $('#costcoModalBtn2').click();
                }
            });
        },

    };
    if (typeof window.COSTCO === 'undefined') {
        window.COSTCO = {};
    }
    window.COSTCO.SecureKeyMemberVerification = SecureKeyMemberVerification;
    return SecureKeyMemberVerification;
});



// WEBPACK FOOTER //
// ./js/account/secure-key-member-verification.js